/**
 * invoiceManager接口
 */
import axios from '../utils/https' // 导入http中创建的axios实例

const meetingReceiptManager = {
  getCompanyList (params) {
    return axios.post('/api/MeetingReceipt/GetCompanyList', params)
  },
  getMeetingReceiptList (params) {
    return axios.get('/api/MeetingReceipt/GetMeetingReceiptList', { params })
  },
  managerEditMeetingReceipt (params) {
    return axios.post('/api/MeetingReceipt/ManagerEditMeetingReceipt', params)
  },
  deleteMeetingReceipt (params) {
    return axios.delete('/api/MeetingReceipt/DeleteMeetingReceipt', { params })
  },
  getMeetingReceiptAllList (params) {
    return axios.get('/api/MeetingReceipt/GetMeetingReceiptAllList', { params })
  },
  exportMeetingReceiptList (params) {
    return axios({
      method: 'post',
      url: '/api/MeetingReceipt/ExportMeetingReceiptList',
      data: params,
      responseType: 'blob'
    })
  }
}

export default meetingReceiptManager
